import { ActionType, createAction } from 'typesafe-actions'
import { NavigateFunction } from 'react-router'

import { ConfigLoadingState, ContentConfiguration, JsonConfig } from './types'

export const setJsonConfig = createAction('CONFIG/SET_CONFIG')<{ config: JsonConfig }>()
export const fetchContentConfiguration = createAction('CONFIG/FETCH_CONTENT_CONFIGURATION')<{
  lang: string
  navigate: NavigateFunction
}>()
export const setContentConfiguration = createAction('CONFIG/SET_CONTENT_CONFIGURATION')<{
  contentConfig: ContentConfiguration
}>()

export const ConfigActions = {
  fetchContentConfiguration,
  setContentConfiguration,
  setJsonConfig,
  setConfigLoadingState: createAction('CONFIG/set-loading-state')<{
    state: ConfigLoadingState
    loadedLanguage?: string
  }>(),
  setApiBlocked: createAction('CONFIG/SET_API_BLOCKED')<boolean>()
}

export type ConfigActions = ActionType<typeof ConfigActions>
